import React, { Component, Fragment } from "react";
import UISectionHeader from "../../Common/UISectionHeader";
import { languageService } from "../../../Language/language.service";
import { hosMistakenSearchFiltersFormSchema } from "./schemas/hosSearchFiltersFormSchema";
import _ from "lodash";
import CustomForm from "../../../libraries/form";
import { userListByGroupRequest, userListRequest } from "../../../reduxRelated/actions/userActions";
import { CRUDFunction } from "../../../reduxCURD/container";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import SpinnerLoader from "../../Common/SpinnerLoader";
import HosSearchRecordsView from "../HosReport/HosSearchRecordsView";
import TopMessageBar from "../../../libraries/TopMessageBar";
import { dataFormatters } from "../../../utils/dataFormatters";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import SvgIcon from "react-icons-kit";
import { PillTextButton } from "../../../libraries/GeneralButtons";
import { printer } from "react-icons-kit/icomoon/printer";
import DetailsOfServiceReport from "../HosReport/DetailsOfServiceReport";
import MistakenRecordsBatchListContainer from "./MistakenRecordsBatchList";
import moment from "moment";
class MistakenHosReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showloader: false,
      searchFilters: { employeeEmail: "" },
      selectedUser: null,
      users: [],
      completeHosReport: {
        batch: null,
        reportData: null,
        showReport: false,
      },
      showFullReport: false,
      singleReport: null,
    };
    this.searchRecords = this.searchRecords.bind(this);
    this.compileSearchHosRecordsFormSchema = this.compileSearchHosRecordsFormSchema.bind(this);
    this.handleReportSearchOnView = this.handleReportSearchOnView.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.setSingleReportView = this.setSingleReportView.bind(this);
    this.loadUserFromRetainedState = this.loadUserFromRetainedState.bind(this);
  }

  componentDidMount() {
    // Fetch All Users
    this.props.userListRequest();
  }
  async loadUserFromRetainedState() {
    const { stateRetention, getHosMistakenReports } = this.props;
    if (stateRetention.userEmail) {
      let foundUser = this.state.users.find((user) => user.email === stateRetention.userEmail);
      this.setState({
        searchFilters: {
          ...this.state.searchFilters,
          employeeEmail: stateRetention.userEmail,
        },
        completeHosReport: {
          batch: null,
          reportData: null,
          showReport: false,
        },
        showFullReport: false,
        singleReport: null,
        selectedUser: foundUser,
      });
    }
  }
  componentDidUpdate(prevProps) {
    const { userActionType, userList, actionType, HosMistakenReports } = this.props;
    const { completeHosReport } = this.state;
    if (userActionType !== prevProps.userActionType) {
      if (userActionType === "USER_LIST_REQUEST") {
      } else if (userActionType === "USER_LIST_SUCCESS") {
        // save select options for users
        if (Array.isArray(userList)) {
          const userSelectOptions = [
            { val: "", text: languageService("Select") },
            ...userList
              .sort((a, b) => a.name.localeCompare(b.name))
              .filter((user) => user.HosInfo && user.HosInfo.startDate && user.HosInfo.timezone)
              .map((user) => ({
                val: user.email,
                text: `${user.name} (${user.email})`,
              })),
          ];

          this.setState(
            {
              users: [...userList],
              searchFiltersFormSchema: this.compileSearchHosRecordsFormSchema(userSelectOptions),
            },
            () => this.loadUserFromRetainedState(),
          );
        }
      } else if (userActionType === "USER_LIST_FAILURE") {
      }
    }
    if (actionType !== prevProps.actionType) {
      if (actionType === "HOSMISTAKENREPORTS_READ_SUCCESS") {
        this.setState({
          showloader: false,
          completeHosReport: {
            ...completeHosReport,
            reportData: HosMistakenReports,
            showReport: true,
          },
        });
      }
      if (actionType === "HOSMISTAKENREPORTS_READ_REQUEST") {
        this.setState({
          showloader: true,
          completeHosReport: {
            ...completeHosReport,
            reportData: null,
            showReport: false,
          },
        });
      }
    }
  }
  compileSearchHosRecordsFormSchema(userSelectOptions) {
    let formSchema = updateShortSchema(_.cloneDeep(hosMistakenSearchFiltersFormSchema), {
      employeeEmail: {
        selectOptions: userSelectOptions,
      },
    });
    return formSchema;
  }
  async searchRecords(submission) {
    this.setState({
      searchFilters: _.cloneDeep(submission.fields),
      completeHosReport: {
        batch: null,
        reportData: null,
        showReport: false,
      },
      showFullReport: false,
      singleReport: null,
    });
    const { employeeEmail } = submission.fields;

    if (employeeEmail) {
      let foundUser = this.state.users.find((user) => user.email === employeeEmail);
      if (foundUser) {
        this.setState({ selectedUser: foundUser });
        this.props.stateRetention.set("userEmail", employeeEmail);
      }
    }
  }

  async handleReportSearchOnView(batch) {
    //prepare query
    const { batchId } = batch;
    this.setState({ completeHosReport: { batch } });
    if (this.props.getHosMistakenReports) await this.props.getHosMistakenReports(`mistakenRecords/batchReport/${batchId}`);
  }
  handleBack() {
    this.setState({
      completeHosReport: {
        batch: null,
        reportData: null,
        showReport: false,
      },
      showFullReport: false,
    });
  }
  printReport() {
    window.print();
  }
  setSingleReportView(singleReport) {
    this.setState({ singleReport: singleReport });
  }
  render() {
    const { searchFilters, searchFiltersFormSchema, completeHosReport, selectedUser, showFullReport, singleReport } = this.state;
    const { batch, reportData, showReport } = completeHosReport;
    return (
      <div>
        <div className="no-print">
          <UISectionHeader title={languageService("Search Mistaken HOS Reports")} />
          <SpinnerLoader spinnerLoading={this.state.showloader} />
          {searchFiltersFormSchema && searchFilters && (
            <CustomForm
              hideFormTitle={true}
              mode="inline"
              fieldsData={searchFilters}
              formSchema={searchFiltersFormSchema}
              parentRef={{
                searchRecords: this.searchRecords,
              }}
            />
          )}
          {!showReport && <MistakenRecordsBatchListContainer onViewClick={this.handleReportSearchOnView} selectedUser={selectedUser} />}
        </div>

        {showReport && (
          <div>
            {!singleReport && (
              <Fragment>
                <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
                  <div
                    className="report-arrow"
                    style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                    onClick={(e) => {
                      this.handleBack();
                    }}
                  >
                    <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                      {languageService("Back")}
                    </span>
                    <SvgIcon icon={arrowLeft} size={24} />
                  </div>
                </div>
                <UISectionHeader
                  title={languageService("Results")}
                  className={"no-print"}
                  postTitleContent={
                    reportData.days.length && (
                      <Fragment>
                        <PillTextButton
                          title={showFullReport ? languageService("Summary") : languageService("Reports")}
                          onClick={() => {
                            this.setState({
                              showFullReport: !showFullReport,
                            });
                          }}
                        />
                        {showFullReport && (
                          <div
                            className="report-print"
                            style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                            onClick={this.printReport}
                          >
                            <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                              {languageService("Print Report")}
                            </span>
                            <SvgIcon icon={printer} size={24} />
                          </div>
                        )}
                      </Fragment>
                    )
                  }
                />

                <Fragment>
                  <TopMessageBar
                    message={`${languageService("Showing")} ${reportData.days.length} ${languageService(
                      "records from",
                    )} ${dataFormatters.dateFormatterWithTimezone(moment(batch.mistakenRecordsInfo.startDate).startOf("day"))} ${languageService(
                      "to",
                    )} ${dataFormatters.dateFormatterWithTimezone(moment(batch.mistakenRecordsInfo.lastRecordDate).startOf("day"))}.`}
                    type={"Info"}
                  />
                  <HosSearchRecordsView
                    days={reportData.days}
                    latestHosRecord={reportData.latestHosRecord}
                    timezone={batch.timezone}
                    user={selectedUser}
                    showFullReport={showFullReport}
                    setSingleReportView={this.setSingleReportView}
                  />
                </Fragment>
              </Fragment>
            )}

            {singleReport && (
              <Fragment>
                <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
                  <div
                    className="report-arrow"
                    style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                    onClick={(e) => {
                      this.setState({ singleReport: null });
                    }}
                  >
                    <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                      {languageService("Back")}
                    </span>
                    <SvgIcon icon={arrowLeft} size={24} />
                  </div>
                  <div
                    className="report-print"
                    style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                    onClick={(e) => {
                      this.printReport();
                    }}
                  >
                    <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                      {languageService("Print Report")}
                    </span>
                    <SvgIcon icon={printer} size={24} />
                  </div>
                </div>
                <div className="print" style={{ overflowX: "auto" }}>
                  <DetailsOfServiceReport {...singleReport} />
                </div>
              </Fragment>
            )}
          </div>
        )}
      </div>
    );
  }
}

let variableList = {
  userReducer: {
    userList: [],
    userListByGroup: [],
  },
};
let reducers = ["userReducer"];

let actionOptions = {
  read: true,
  others: { userListRequest, userListByGroupRequest },
};

const HosMistakenReportContainer = CRUDFunction(
  MistakenHosReport,
  "HosMistakenReport",
  actionOptions,
  variableList,
  reducers,
  "hoursofservice",
);

export default HosMistakenReportContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosMistakenReport/index.jsx